<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconDoubleChevronUp_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M7.469 4.183 4.352 7.299a.623.623 0 1 0 .881.882L7.91 5.505l2.676 2.676a.623.623 0 1 0 .882-.882L8.35 4.183a.623.623 0 0 0-.881 0Zm-.105 3.636-3.117 3.116a.623.623 0 1 0 .882.882L7.805 9.14l2.676 2.676a.623.623 0 1 0 .882-.882L8.246 7.82a.623.623 0 0 0-.882 0Z"
        clip-rule="evenodd"
    />
</svg>
